module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-15-2c3a8bddc3fbd6ad9b886277162b0256.jpg";